import * as React from 'react';
import { TeamDecisionStore } from 'nomst/Stores/Decision/teamDecision.store';
import { DecisionDispatcher } from 'nomst/Stores/Decision/decision.dispatcher';
import { observer } from 'mobx-react';
import CountryBudgetDecision from 'nomst/Components/Decision/countryBudgetDecision';
import TeamDecisionHeader from 'nomst/Components/Decision/teamDecisionHeader';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { User } from 'nomst/Stores/User/user';
import { NavigationStore } from 'nomst/Stores/Navigation/navigation.store';
import { WorkflowStatusListType } from 'typings/enums';
import { managerListSidePanelStore } from 'utils/MobxDataManager/singletons';
import './teamDecision.scss';
import { ManagerWorkflowStore } from 'nomst/Stores/Decision/managerWorkflow.store';

export interface ITeamDecisionProps {
    teamDecisionStore: TeamDecisionStore;
    decisionDispatcher: DecisionDispatcher;
    configuration: Configuration;
    user: User;
    currentManagerIds: string[];
    directReportsCount: number;
    allReportsCount: number;
    navigationStore: NavigationStore;
    workflowStatus: Nullable<WorkflowStatusListType>;
    budgetCycleId: Nullable<number>;
    shouldHideChangeHistory: Nullable<boolean>;
    managerWorkflowStore: ManagerWorkflowStore;
}

export class TeamDecision extends React.Component<ITeamDecisionProps> {
    render(): React.ReactNode {
        const { configuration, teamDecisionStore, currentManagerIds } = this.props;

        if (!managerListSidePanelStore.allManagerIds.length) {
            return (
                <div className="employees-container">
                    {this.renderEmptyContainer()}
                </div>
            );
        }

        return (
            <div>
                <TeamDecisionHeader
                    configuration={configuration}
                    teamDecisionDispatcher={teamDecisionStore.teamDecisionDispatcher}
                    teamDecisionStore={this.props.teamDecisionStore}
                    selectedIsoCurrencyCode={teamDecisionStore.currentIsoCurrencyCode}
                    selectedEmployeeSort={teamDecisionStore.employeeSort}
                    showPromotionsOnly={teamDecisionStore.showPromotionsOnly}
                    currentManagerIds={currentManagerIds}
                    directReportsCount={this.props.directReportsCount}
                    allReportsCount={this.props.allReportsCount}
                    navigationStore={this.props.navigationStore}
                    workflowStatus={this.props.workflowStatus}
                    budgetCycleId={this.props.budgetCycleId}
                    shouldHideChangeHistory={this.props.shouldHideChangeHistory}
                    managerWorkFlowStore={this.props.managerWorkflowStore}
                    currentUser={this.props.user}
                />
                <div className="employees-container">
                    {this.renderCountryBudgetDecisions()}
                </div>
            </div>
        );
    }

    private renderEmptyContainer(): React.ReactNode {
        return (
            <div className="no-employees">
                <img alt=""
                    src={require('contents/employee.svg')}
                    className="no-employee-icon"
                />
                <h3 className="no-employee-header-text">
                    You have no teams.
                </h3>
                <div className="no-employee-body-text">
                    Switch summaries to view more teams
                </div>
            </div>
        );
    }

    private renderCountryBudgetDecisions(): React.ReactNode {
        const { teamDecisionStore, configuration, user, decisionDispatcher } = this.props;
        return teamDecisionStore.countryBudgetDecisions.map((countryBudgetDecision, index) => {
            const isFirst = index === 0;
            return (
                <CountryBudgetDecision
                    key={countryBudgetDecision.code}
                    decisionDispatcher={decisionDispatcher}
                    countryBudgetDecision={countryBudgetDecision}
                    configuration={configuration}
                    user={user}
                    useCollapse={this.useCollapse}
                    showExpandedByDefault={isFirst}
                    isDirectsOnly={teamDecisionStore.isDirectOnly}
                    selectedCurrency={teamDecisionStore.currentIsoCurrencyCode}
                />
            );
        });
    }

    private get useCollapse(): boolean {
        const { teamDecisionStore } = this.props;
        return teamDecisionStore.countryBudgetDecisions.length > 1;
    }
}

export default observer(TeamDecision);